<template>
  <div class="p-grid p-col-12">
      <div class="p-col-12 p-md-12 p-lg-12 no-padding-margin-bottom-top">
          <card class="p-col-12" :header="$t('protocol.tab-timeline.timeline-information')" >

              <div class="p-grid p-col-12">
                  <Button class="p-button-outlined p-mr-2 p-mb-2 p-button p-component" @click.prevent="newTimeline({ displayDate: new Date() })">
                    <span class="p-button-label">
                      <i class="fa-solid fa-plus p-mr-2"></i>{{$t('protocol.tab-timeline.newEvent')}}
                    </span>
                  </Button>
                  <coff-input-text v-model="protocol.publicAccessCode" label="forms.protocol.access-code" class="p-col-3 p-md-3 p-lg-3" :disable="true"/>
                  <a class="cursor-pointer p-ml-3" @click.prevent="openPublicTimeline" style="margin-top: 30px;"><i class="fa fa-link" :title="$t('protocol.tab-timeline.open-client-timeline')"/></a>
              </div>

              <hr style="width: 100%;"/>

              <DataTable v-if="timelines.length > 0" :value="timelines" class="p-datatable-customers" :rows="5" style="margin-bottom: 20px" :paginator="false">
                  <Column :header="$t('protocol.tab-timeline.name')" headerClass="p-col-12 p-md-2 p-lg-2">
                      <template #body="slotProps">
                          {{ slotProps.data.name ? slotProps.data.name : '-' }}
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-timeline.status')" headerClass="p-col-12 p-md-3 p-lg-3">
                      <template #body="slotProps">
                          {{ slotProps.data.color ? getTimelineStatus(slotProps.data.color) : '-' }}
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-timeline.displayDate')" headerClass="p-col-12 p-md-3 p-lg-3">
                      <template #body="slotProps">
                          {{$d(new Date(slotProps.data.displayDate), 'long')}}
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-timeline.actions')" headerClass="p-col-12 p-md-1 p-lg-1">
                      <template #body="slotProps">
                          <a class="cursor-pointer" @click.prevent="newTimeline({...slotProps['data'] })"><i class="p-ml-2 pi pi-pencil small" :title="$t('protocol.tab-timeline.edit')"/></a>
                          <a class="cursor-pointer" @click.prevent="remove(slotProps.data.id)"><i class="p-ml-2 pi pi-times small" :title="$t('protocol.tab-timeline.delete')"/></a>
                      </template>
                  </Column>
              </DataTable>

              <Message v-else class="p-col-12" severity="warn" style="white-space: pre-line;">{{$t('protocol.tab-timeline.no-timelines')}}</Message>

          </card>
      </div>
  </div>
</template>

<script>

import ProtocolTimelineBusiness from "@/business/ProtocolTimelineBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import DialogService from "@/business/ModalBusiness";
import ModalTimeline from "@/viewer/protocol/tabs/timeline/ModalTimeline.vue";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import TimelinePredefinitionBusiness from "@/business/TimelinePredefinitionBusiness";
import { _getTimelineStatus } from "@/constants/Timeline";

export default {
      name: "TabTimelineProtocol",
      components: {},

      props:{
            protocol: {type: Object, default: () => {return {}}},
      },

      async mounted() {
          await this.loadTimelines();
          await this.loadTimelinesPredefined();
      },

      data(){
            return{
                timelines: [],
                getTimelineStatus: _getTimelineStatus,
                timelinesPredefined: [],
            }
      },

      methods:{

          async loadTimelines() {
            const response = await ProtocolTimelineBusiness.getAll(this.protocol.id).catch((e) => ToastMessageBusiness.showError(e.message));
            if(response){
                this.timelines = [...response].sort((a, b) => new Date(a.displayDate) - new Date(b.displayDate));
            }
          },

          async loadTimelinesPredefined() {
            const response = await TimelinePredefinitionBusiness.getAll().catch((e) => ToastMessageBusiness.showError(e.message));
            if(response){
                this.timelinesPredefined = response;
            }
          },

          async newTimeline(timelineEntity) {
            const timelineSave = await DialogService.openModal(ModalTimeline, {timelineEntity: timelineEntity, protocolId: this.protocol.id, timelinesPredefined: this.timelinesPredefined});
            if(timelineSave){
                const saved = await ProtocolTimelineBusiness.save(timelineSave, this.protocol.id, timelineSave.id).catch((e) => ToastMessageBusiness.showError(e.message));
                if(saved){
                    await this.loadTimelines();
                    ToastMessageBusiness.showSuccess();
                }
            }
          },

          async remove(timelineId) {
              if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
                  const response = await ProtocolTimelineBusiness.delete(this.protocol.id, timelineId).catch((e) => ToastMessageBusiness.showError(e.message));
                  if(response){
                      await this.loadTimelines();
                      ToastMessageBusiness.showSuccess();
                  }
              }
          },

          async openPublicTimeline(){
            let link = `${location.protocol}//${location.host}/#/public-client/${this.$route.params.id}/status`;
            window.open(link, "_blank")
          },
      }

}
</script>

<style scoped>

  .table-mr {
      margin-right: 30%;
  }

  .no-padding-margin-bottom-top {
    padding-top: 0 !important;
    margin-top: 0 !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .force-mb-0 {
    margin-bottom: 0rem !important;
  }

  .force-mt-0 {
    margin-bottom: 0rem !important;
  }

  .avatar {
    width: 55px;
    border-radius: 80px;
  }

  .cursor-pointer {
    cursor: pointer !important;
  }

</style>